export const sidebarItemsPlugin = [
  {
    sectionTitle: "About",
    eventKey: "0",
    items: [],
    href: "/about",
  },
  {
    sectionTitle: "Getting Started",
    eventKey: "1",
    items: [
      { label: "Installation", href: "/getting-started/installation" },
      { label: "Enable Plugin", href: "/getting-started/enableplugin" },
    ],
  },
  {
    sectionTitle: "Configuration",
    eventKey: "2",
    items: [
      { label: "Configuration Settings", href: "/configuration/configuration-settings" },
      { label: "Customize General", href: "/configuration/customize-general" },
      { label: "Customize Priorities", href: "/configuration/customize-priorities" },
      { label: "Customize Statuses", href: "/configuration/customize-statuses" },
    ],
  },
  {
    sectionTitle: "Test Cases",
    eventKey: "3",
    items: [
      { label: "Create a Test Case", href: "/testcase/create-test-case" },
      { label: "Import a Test Cases", href: "/testcase/import-test-case" },
      { label: "Delete a Test Cases", href: "/testcase/delete-test-case" },
      { label: "More Test Case Actions", href: "/testcase/test-case-actions" },
    ],
  },
  {
    sectionTitle: "Test Cycles",
    eventKey: "4",
    items: [
      { label: "Create a Test Cycle", href: "/testcycle/create-test-cycle" },
      { label: "Executing a Test Cycle", href: "/testcycle/execute-test-cycle" },
      { label: "Delete a Test Cycle", href: "/testcycle/delete-test-cycle" },
      // { label: "Create or Link to a Jira Issue", href: "/testcycle/link-to-jira-issue" },
      { label: "More Test Cycle Actions", href: "/testcycle/test-cycle-actions" },
    ],
  },
  {
    sectionTitle: "Dashboard",
    eventKey: "5",
    items: [
      { label: "Introduction", href: "/dashboard/introduction" },
      { label: "Test Metrics", href: "/dashboard/graph-info" },
    ],
  },
  {
    sectionTitle: "Automation",
    eventKey: "6",
    items: [
      { label: "Automation Environment Setup", href: "/automation/setting-up-the-environment" },
      { label: "Assigning Job/Workflow", href: "/automation/assign-job" },
      { label: "Running an Automation", href: "/automation/running-execution" },
    ],
  },
  {
    sectionTitle: "APIs",
    eventKey: "7",
    items: [
      { label: "API Access Token", href: "/API/generate-token" },
      { label: "Update Execution Status", href: "/API/update-execution-status" },
    ],
  },
];

export const sidebarItemsTool = [
  {
    sectionTitle: "About",
    eventKey: "0",
    items: [],
    href: "/about?type=tool",
  },
  {
    sectionTitle: "Getting Started",
    eventKey: "1",
    items: [
      { label: "Register", href: "/getting-started/registration?type=tool" },
      { label: "Adding Collaborators", href: "/getting-started/adding-users?type=tool" },
      { label: "Home", href: "/getting-started/home?type=tool" },
    ],
  },
  {
    sectionTitle: "Projects",
    eventKey: "8",
    items: [
      { label: "Integrate JIRA", href: "/projects/connect-to-jira?type=tool" },
      { label: "View All Projects", href: "/projects/view-all-projects?type=tool" },
      { label: "Add a Project", href: "/projects/add-project?type=tool" },
      { label: "Project workflows", href: "/projects/project-workflows?type=tool" },
      { label: "Project Team", href: "/project-team/list?type=tool" },
    ],
  },
  {
    sectionTitle: "Configuration",
    eventKey: "2",
    items: [
      { label: "Configuration Settings", href: "/configuration/configuration-settings?type=tool" },
      { label: "Customize General", href: "/configuration/customize-general?type=tool" },
      { label: "Customize Priorities", href: "/configuration/customize-priorities?type=tool" },
      { label: "Customize Statuses", href: "/configuration/customize-statuses?type=tool" },
    ],
  },
  // {
  //   sectionTitle: "Project Team",
  //   eventKey: "9",
  //   items: [
  //     { label: "List", href: "/project-team/list?type=tool" },
  //     { label: "Add Role", href: "/project-team/add-role?type=tool" },
  //   ],
  // },
  {
    sectionTitle: "Test Suites",
    eventKey: "3",
    items: [
      { label: "Create a Test Suite", href: "/testsuite/create-test-suite?type=tool" },
      { label: "Test Suite Actions", href: "/testsuite/test-suite-actions?type=tool" },
      { label: "Adding Test Suite to a Test Case", href: "/testsuite/add-test-suite-to-testcase?type=tool" },
    ],
  },
  {
    sectionTitle: "Test Cases",
    eventKey: "4",
    items: [
      { label: "Create a Test Case", href: "/testcase/create-test-case?type=tool" },
      { label: "Import a Test Cases", href: "/testcase/import-test-case?type=tool" },
      { label: "Export a Test Cases", href: "/testcase/export-test-case?type=tool" },
      { label: "Delete a Test Cases", href: "/testcase/delete-test-case?type=tool" },
      { label: "More Test Case Actions", href: "/testcase/test-case-actions?type=tool" },
    ],
  },
  {
    sectionTitle: "Test Cycles",
    eventKey: "5",
    items: [
      { label: "Create a Test Cycle", href: "/testcycle/create-test-cycle?type=tool" },
      { label: "Adding Test Cases", href: "/testcycle/add-test-cases?type=tool" },
      { label: "Executing a Test Cycle", href: "/testcycle/execute-test-cycle?type=tool" },
      { label: "Delete a Test Cycle", href: "/testcycle/delete-test-cycle?type=tool" },
      // { label: "Create or Link to a Jira Issue", href: "/testcycle/link-to-jira-issue?type=tool" },
      { label: "More Test Cycle Actions", href: "/testcycle/test-cycle-actions?type=tool" },
    ],
  },
  {
    sectionTitle: "Test Intelligence",
    eventKey: "6",
    items: [
      { label: "Test plans", href: "/test-intelligence/testplans?type=tool" },
    ],
  },
  {
    sectionTitle: "Metrics",
    eventKey: "7",
    items: [
      { label: "Introduction", href: "/dashboard/introduction?type=tool" },
      { label: "Test Metrics", href: "/dashboard/graph-info?type=tool" },
    ],
  },
  {
    sectionTitle: "Automation",
    eventKey: "8",
    items: [
      { label: "Automation Environment Setup", href: "/automation/setting-up-the-environment?type=tool" },
      { label: "Assigning Job/Workflow", href: "/automation/assign-job?type=tool" },
      { label: "Running an Automation", href: "/automation/running-execution?type=tool" },
    ],
  },
  {
    sectionTitle: "APIs",
    eventKey: "9",
    items: [
      { label: "API Access Token", href: "/API/generate-token?type=tool" },
      { label: "Update Execution Status", href: "/API/update-execution-status?type=tool" },
    ],
  },
];